import gqlClient from '../client/gqlClient';
import gql from 'graphql-tag';

export const mutationInviteRejectByCreator = async ({id, rejectReason}) => {
    try {
        if (gqlClient.client === undefined) {
            await gqlClient.createClient();
        }
        if (gqlClient.client === undefined) {
            throw new Error('Unable to create client');
        }
        return await gqlClient.client.mutate({
            mutation: gql`
                mutation InviteRejectByCreator($input: InviteRejectCreateInput!) {
                    inviteRejectByCreator(input: $input) {
                        wasSuccessful
                        userErrors {
                            message
                        }
                    }
                }
            `,
            variables: {
                input: {
                    inviteUuid: id,
                    rejectReasons: [
                        {reason: rejectReason.reason, description: rejectReason.payment || ''}
                    ]
                }
            }
        });
    } catch (error) {
        console.error('Mutation InviteRejectByCreator error: ', error);
    }
};



// WEBPACK FOOTER //
// ./graphql/mutations/mutationInviteRejectByCreator.js